import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-session-warning-dialog',
    template: `
    <div class="d-flex gap-2">Du blir automatisk utloggad snart: <app-timer></app-timer></div>

    <div class="d-flex justify-content-between">
      <app-button text="Logga ut" buttonStyle="secondary" (click)="cancel()"></app-button>
      <app-button text="Fortsätt vara inloggad" buttonStyle="primary" (click)="ok()"></app-button>
    </div>
  `,
    standalone: false
})
export class SessionWarningDialogComponent {
  constructor(private dialogRef: DynamicDialogRef<SessionWarningDialogComponent>) {}

  ok(): void {
    this.dialogRef.close(true);
  }
  cancel(): void {
    this.dialogRef.close(false);
  }
}
